import PropTypes from 'prop-types';
import React from 'react';

import LinkRowItem from './LinkRowItem';

import primaryLinksStyles from './PrimaryLinks-style.scss';
import siteLinksStyles from './SiteLinks-style.scss';
import legalLinksStyles from './LegalLinks-style.scss';
import sitemapLinksStyles from './SitemapLinks-style.scss';

const styleMap = {
    primary: primaryLinksStyles,
    site: siteLinksStyles,
    legal: legalLinksStyles,
    sitemap: sitemapLinksStyles
};

const LinkRow = (props) => {
    const { type, items } = props;
    const style = styleMap[type] || {};

    return (
        <nav>
            <div className={style.row}>
                {items.map(item => <LinkRowItem key={item.dataTn} {...item} styles={style} />)}
            </div>
        </nav>
    );
};

LinkRow.propTypes = {
    items: PropTypes.array,
    type: PropTypes.string
};

export default LinkRow;



// WEBPACK FOOTER //
// ./src/components/Footer/LinkRow/LinkRow.jsx